import type { Theme } from "@emotion/react";
import { css } from "@emotion/react";

import * as colors from "@styles/emotion-styles/colors";
import * as dimensions from "@styles/emotion-styles/dimensions";
import * as helpers from "@styles/emotion-styles/helpers";
import * as utilities from "@styles/emotion-styles/utilities";

export const form = (theme: Theme) => css`
  display: inline-block;
  border-radius: ${dimensions.borderRadius};
  border: 1px solid ${theme.system.borderBase};
  cursor: pointer;
  ${utilities.transition}

  &:hover {
    box-shadow: 0 1px 2px 0 ${helpers.hexToRgba(theme.text.body, 0.25)};
    border: 1px solid ${theme.system.borderHover};
  }

  &:active {
    border: 1px solid ${theme.system.borderActive};
  }
`;

export const formDisabled = (theme: Theme) => css`
  background-color: ${theme.disabled.background};
  border-color: ${theme.disabled.border};
  cursor: not-allowed;

  &:hover {
    box-shadow: none;
    border-color: ${theme.system.borderBase};
  }

  &:active {
    background-color: ${theme.disabled.background};
  }
`;

export const formDS4 = (theme: Theme) => css`
  background-color: ${theme.text.onBackground};
  border-radius: ${dimensions.borderRadius};
`;

export const AppleSSOButton = css`
  display: flex;
  align-content: center;
  width: 250px;
  padding: 0.5625rem 0.3125rem 0.5625rem 0.5625rem;
  cursor: pointer;
  justify-content: center;

  input {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    font-weight: 500;
  }
`;

export const submit = () => css`
  font-family: "Roboto", sans-serif;
  background: ${colors.white};
  border: none;
  font-size: 1rem;
  color: ${colors.black}; // TODO: Update with Aviary accent color - BLACK
  cursor: pointer;
  padding-bottom: 0;
`;

export const appleSSOButtonDS4 = (theme: Theme) => css`
  background-color: ${theme.text.onBackground};
  border-radius: ${dimensions.borderRadius};
`;

export const submitDS4 = (theme: Theme) => css`
  font-family: -apple-system, "Helvetica Neue", sans-serif;
  line-height: 0.9;
  background: ${theme.text.onBackground};
  border-radius: ${dimensions.borderRadius};
  color: ${theme.surface.overlayDark};
`;

export const submitDisabled = (theme: Theme) => css`
  color: ${theme.disabled.text};
  background-color: ${theme.disabled.background};
  cursor: not-allowed;
`;

export const logo = css`
  width: 1.3125rem;
  height: 1.3125rem;
  margin-right: 0.1rem;
`;

export const disabled = css`
  cursor: not-allowed;
`;

export const orSection = (theme: Theme) => css`
  margin: 1rem 0;
  color: ${theme.system.textBase};
  overflow: hidden;
  text-transform: uppercase;

  &:before,
  &:after {
    background-color: ${theme.system.backgroundMutedActive};
    content: "";
    display: inline-block;
    height: 1px;
    position: relative;
    vertical-align: middle;
    width: 25%;
  }

  &:before {
    right: 0.5rem;
    margin-left: -50%;
  }

  &:after {
    left: 0.5rem;
    margin-right: -50%;
  }
`;

export const buttonWrapper = css`
  text-align: center;
  width: 100%;
`;
